import { moduleFactory } from "@/store/resource";

const resourceModule = moduleFactory("mailSubject");

resourceModule.mutations.oldDelete = resourceModule.mutations.delete;
resourceModule.mutations.delete = (state, id) => {
  state["mailSubjects"].forEach(function(element) {
    if (element.subjects.findIndex(resource => resource.id == id) >= 0) {
      element.subjects.splice(
        element.subjects.findIndex(resource => resource.id == id),
        1
      );
    }
  });
};

export const mailSubjectModule = resourceModule;
